export function commonGetNextPageParam(lastPage: { paging: Pagination }) {
  const { index, size, total } = lastPage.paging

  if (index + size < total) {
    return index + size
  }

  return undefined
}
